import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=108f623e&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=js&"
export * from "./ProfileView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=108f623e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f623e",
  null
  
)

export default component.exports